import React from 'react';
import { FAQ } from '../components/FAQ';
import { useScreenInit } from '../useScreenInit';
import { PricingSection } from '../components/PricingSection';
import { PricingCreditsUseCases } from '../components/PricingCreditsUseCases';
import { PricingClosingCTA } from '../components/PricingClosingCTA';
export function Pricing() {
  useScreenInit('Pricing');
  return <div className="min-h-screen bg-[#FAF8F4] pt-16" data-id="element-10032" data-mp="3v6y5nvfo4z01">
      <PricingSection data-id="element-10033" data-mp="3r7ytbprlxzyk" />

      <PricingCreditsUseCases data-id="element-10034" data-mp="3r8id7c0tiyf8" />

      <div className="bg-[#FAF8F4] pb-20" data-id="element-10035" data-mp="3m8dtze8izplb">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10" data-id="element-10036" data-mp="3m7b5fcyodz8k">
          {/* FAQ Section */}
          <div className="border-t border-neutral-200 pt-20" data-id="element-10037" data-mp="3h9sslbhjezva">
            <div className="text-center mb-12" data-id="element-10038" data-mp="3ca6gx6hcxrol">
              <h2 className="text-3xl md:text-4xl font-title font-bold text-[#2B211A]" data-id="element-10039" data-mp="3cbhkb56w4xf6">
                Frequently Asked Questions
              </h2>
            </div>
            <FAQ data-id="element-10040" data-mp="1aibihsk43job" />
          </div>
        </div>
      </div>

      <PricingClosingCTA data-id="element-10041" data-mp="1agqp469ja6s1" />
    </div>;
}